import React from 'react';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import { Box, Icon } from '@material-ui/core';
import styles from './styles';
import { ButtonProps, ButtonThemes } from './types';
import colors from '../../../assets/styles/colors';

const CustomButton = withStyles(theme => ({
  root: {
    textTransform: 'none',
  },
}))(Button);

function ButtonComponent({
  children,
  disabled,
  colorDetails,
  theme = 'primary',
  style,
  alignSelf,
  flex,
  icon,
  iconRight,
  loading,
  justifyContent,
  ...rest
}: ButtonProps & {
  icon?: JSX.Element;
  iconRight?: JSX.Element;
  loading?: boolean;
  justifyContent?: string;
}): JSX.Element {
  const color = getColor(
    colorDetails,
    theme,
    disabled || false,
    loading || false,
  );

  function getColorText(type: ButtonThemes) {
    switch (type) {
      case 'primary':
        return colors.secondary.white;
      case 'secondary':
        return colors.secondary.white;
      case 'outline-primary':
        return colors.primary.orange;
      case 'red':
        return colors.secondary.white;
      case 'outline-red':
        return colors.error.deepRed;
      case 'ghost':
        return colors.secondary.white;
      case 'disabled':
        return colors.secondary.deepSky;
      default:
        return 'white';
    }
  }
  const alignButton = alignSelf ?? 'auto';

  function themeButton(type: ButtonThemes): any {
    switch (type) {
      case 'primary':
        return {
          backgroundColor:
            !disabled && !loading
              ? colors.primary.orange
              : colors.secondary.brightBlue,
          borderColor: 'transparent',
        };
      case 'outline-primary':
        return {
          backgroundColor: colors.secondary.white,
          borderWidth: 2,
          borderColor:
            !disabled && !loading
              ? colors.primary.orange
              : colors.secondary.brightBlue,
        };
      case 'secondary':
        return {
          backgroundColor:
            !disabled && !loading ? '#fe7b17' : colors.secondary.brightBlue,
          borderColor: colors.secondary.brightBlue,
        };
      case 'red':
        return {
          backgroundColor:
            !disabled && !loading
              ? colors.error.deepRed
              : colors.secondary.brightBlue,
          borderColor: 'transparent',
        };
      case 'outline-red':
        return {
          backgroundColor: colors.secondary.white,
          borderWidth: 2,
          borderColor:
            !disabled && !loading
              ? colors.error.deepRed
              : colors.secondary.brightBlue,
        };
      case 'ghost':
        return {
          backgroundColor: colors.neutral.gray,
          borderColor: 'transparent',
        };
      case 'disabled':
        return {
          backgroundColor: colors.secondary.brightBlue,
          borderColor: 'transparent',
        };
      default:
        return {
          backgroundColor:
            !disabled && !loading
              ? colors.primary.orange
              : colors.secondary.brightBlue,
          borderColor: 'transparent',
        };
    }
  }

  const classes = styles();

  return (
    <Box
      component={'div'}
      style={{
        display: 'grid',
        justifyContent: justifyContent || 'flex-end',
      }}
    >
      <CustomButton
        disabled={loading || disabled}
        className={`${classes.buttonStyle}  ${classes.borderWidth2}`}
        style={{
          ...themeButton(theme),
          ...style,

          alignSelf: alignButton,
          flexDirection: 'row',
          flexShrink: 1,
          marginTop: (rest.mt || 0) * 4,
          marginBottom: (rest.mb || 0) * 4,
          marginLeft: (rest.ml || 0) * 4,
          marginRight: (rest.mr || 0) * 4,
          flexWrap: 'nowrap',
        }}
        {...rest}
      >
        {icon && <Icon style={{ opacity: loading ? 0 : 1 }}>{icon}</Icon>}
        <span
          style={{
            color: getColorText(theme),
            marginLeft: icon && children ? 8 : 0,
            marginRight: iconRight && children ? 8 : 0,
            opacity: loading ? 0 : 1,
          }}
        >
          {children}
        </span>
        {iconRight && (
          <Icon style={{ opacity: loading ? 0 : 1 }}>{iconRight}</Icon>
        )}
        {loading && (
          <Box
            component={'div'}
            className={classes.loadingStack}
            style={{ left: 0, right: 0, top: 0, bottom: 0, display: 'flex' }}
          >
            <Box
              component={'div'}
              style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <CircularProgress size={20} color="inherit" />
            </Box>
          </Box>
        )}
      </CustomButton>
    </Box>
  );
}
function getColor(
  colorDetails: string | undefined,
  theme: string,
  disabled: boolean,
  loading: boolean,
) {
  let color = !colorDetails ? colors?.primary : colorDetails;
  if (theme.includes('primary') && !disabled && !loading) {
    color = colors?.primary.orange;
  } else if (!disabled && !loading) {
    color = colors.secondary.brightBlue;
  }
  return color;
}

export default ButtonComponent;
